module.exports = __webpack_public_path__ + "img/type-SAQs-active.95ae1a23.svg";